import React, { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import { getSucceededFailedLoginsCount } from "../../../api/LogReport";
import { ParamData } from "../../../types/Param";

interface Props {
  data: ParamData; // contains startingFrom, endingOn
}

const SucceededFailedLogin: React.FC<Props> = ({ data }) => {
  const [dates, setDates] = useState<string[]>([]);
  const [success, setSuccess] = useState<number[]>([]);
  const [failed, setFailed] = useState<number[]>([]);

  useEffect(() => {
    const loadData = async () => {
      try {
        const resp = await getSucceededFailedLoginsCount(data);

        setDates(
          resp.map((x) =>
            new Date(x.attemptDate).toLocaleDateString("en-US", {
              month: "short",
              day: "numeric",
            })
          )
        );

        setSuccess(resp.map((x) => Number(x.successCount)));
        setFailed(resp.map((x) => Number(x.failedCount)));
      } catch (ex) {
        console.error(ex);
      }
    };

    loadData();
  }, [data.startingFrom, data.endingOn]);

  const series = [
    {
      name: "Successful Logins",
      data: success,
    },
    {
      name: "Failed Logins",
      data: failed,
    },
  ];

  const options: ApexCharts.ApexOptions = {
    chart: {
      id: "success-failed-logins",
      type: "bar",
      stacked: false,
      toolbar: { show: false },
    },
    xaxis: {
      categories: dates,
      title: { text: "Date" },
    },
    yaxis: {
      title: { text: "Login Count" },
      min: 0,
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "45%",
        borderRadius: 4,
      },
    },
    dataLabels: {
      enabled: false,
    },
    colors: ["#2ecc71", "#e74c3c"], // green success, red failed
    legend: {
      position: "top",
    },
    grid: {
      borderColor: "#ececec",
    },
  };

  return <Chart options={options} series={series} type="bar" height={325} />;
};

export default SucceededFailedLogin;
